module.exports = __webpack_public_path__ + "img/strophoid_curve.9c3f26a2.png";